(app => {

    app.config($stateProvider => {
        $stateProvider.state("Home.Marketing.Pipelines",
            {
                url: "/Pipelines",
                component: "pipelines",
                data: {
                    pageTitle: "Pipelines"
                }
            });
    });

    app.component("pipelines",
        {
            templateUrl: "/App/Marketing/Pipelines/pipelines.html",
            controller: pipelinesController,
        });

    function pipelinesController(pipelinesDataTable, pipelineApi) {
        var $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.pipelines = [];

            $ctrl.loading = true;

            pipelineApi.getCurrentUserPipelineSummary().then(pipelines => {
                $ctrl.pipelines = pipelines;

                $ctrl.dataTableOptions = pipelinesDataTable.buildDataTableOptions($ctrl.pipelines);

                $ctrl.loading = false;
            });
        }
    }

})(window.app, window.angular); //jshint ignore:line